import { cloneElement } from 'react';
import styled from 'styled-components';
import { getToken } from '@optimus-web/core';

export default ({ children, href, target, onClick, ...other }: $TSFixMe) => (
    <StyledLink
        href={href}
        target={target}
        rel={target === '_blank' ? 'noopener noreferrer' : undefined}
        onClick={onClick}
    >
        {cloneElement(children, other)}
    </StyledLink>
);

const StyledLink = styled.a`
    text-decoration: none !important;

    &:hover {
        color: ${getToken('textStaticPrimary')};
    }
`;
